import React from "react";
import PropTypes from "prop-types";
import _get from "lodash/get";
import { Dropdown } from "semantic-ui-react";
import {
  DeleteButton,
  EditButton,
  ExternalWorkflowButton,
  CopyButton,
} from "../buttons";

export const ActionButton = ({
  record,
  dropdownFluid = false,
  disabled = false,
}) => {
  const state = _get(record, "state");
  const draftId = _get(record, "id");

  return (
    <Dropdown
      onClick={(e) => e.preventDefault()}
      text={"Actions"}
      icon="list"
      floating
      labeled
      button
      basic={true}
      className="icon"
      fluid={dropdownFluid}
      disabled={disabled}
    >
      <Dropdown.Menu>
        <Dropdown.Item>
          <DeleteButton draftId={draftId} state={state} />
        </Dropdown.Item>
        <Dropdown.Item disabled={["running", "submitted"].includes(state)}>
          <EditButton draftId={draftId} />
        </Dropdown.Item>
        <Dropdown.Item disabled={["running", "submitted"].includes(state)}>
          <ExternalWorkflowButton draftId={draftId} />
        </Dropdown.Item>
        <Dropdown.Item>
          <CopyButton draftId={draftId} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

ActionButton.propTypes = {
  record: PropTypes.object.isRequired,
  dropdownFluid: PropTypes.bool,
  disabled: PropTypes.bool,
};
